import { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlined from "@mui/icons-material/VisibilityOffOutlined";
import type { TextFieldProps } from "@mui/material";
import { authFieldSx } from "./auth-surface";

export { authFieldSx } from "./auth-surface";

type TextFieldSxEntry = Extract<NonNullable<TextFieldProps["sx"]>, readonly unknown[]>[number];

export const AuthPasswordField = (props: Omit<TextFieldProps, "type">) => {
  const [visible, setVisible] = useState(false);
  const inheritedSx = Array.isArray(props.sx)
    ? (props.sx as readonly TextFieldSxEntry[])
    : props.sx
      ? [props.sx as TextFieldSxEntry]
      : [];

  return (
    <TextField
      {...props}
      type={visible ? "text" : "password"}
      sx={[authFieldSx, ...inheritedSx]}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={visible ? "Hide password" : "Show password"}
              edge="end"
              onClick={() => setVisible((value) => !value)}
              sx={{ minHeight: 44, minWidth: 44 }}
              type="button"
            >
              {visible ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
